import markUrl from "@chatland/brand/assets/chatland-mark.svg?url";
import wordmarkUrl from "@chatland/brand/assets/chatland-wordmark.svg?url";

type BrandProps = {
  compact?: boolean;
  inverted?: boolean;
  wordmarkOnly?: boolean;
};

export function Brand({
  compact = false,
  inverted = false,
  wordmarkOnly = false,
}: BrandProps) {
  return (
    <span
      class={`brand${inverted ? " brand--inverted" : ""}${wordmarkOnly ? " brand--wordmark-only" : ""}`}
    >
      {!wordmarkOnly && <img class="brand__mark" src={markUrl} alt="" />}
      {!compact && (
        <img class="brand__wordmark" src={wordmarkUrl} alt="Chatland" />
      )}
    </span>
  );
}

export function Mark({ className = "" }: { className?: string }) {
  return <img class={`brand-mark ${className}`} src={markUrl} alt="" />;
}
